export default __webpack_public_path__ + "f3fcafeec7999a623ddcd7ee035354dd.png";